import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function MetaTags() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // 更新 HTML lang 属性
    document.documentElement.lang = i18n.language;

    // 更新 title
    document.title = t('meta.title');

    // 更新或创建 meta 标签
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // 更新 description
    updateMetaTag('description', t('meta.description'));
    
    // 更新 keywords
    updateMetaTag('keywords', t('meta.keywords'));
    
    // 更新 og:title
    updateMetaTag('og:title', t('meta.ogTitle'), true);
    
    // 更新 og:description
    updateMetaTag('og:description', t('meta.ogDescription'), true);

  }, [i18n.language, t]);

  return null;
}
